import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { RemoteShellDataProviderFactory } from '../factory/RemoteShellDataProviderFactory';
import { RemoteShellBaseDataProvider } from '../dataProvider/RemoteShellBaseDataProvider';
import { RemoteShellWebComponentSchema } from '../types';

export class RemoteShellRepository extends BaseWebComponentRepository {
  public dataProviderFactory: RemoteShellDataProviderFactory;
  public dataProvider: RemoteShellBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new RemoteShellDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<RemoteShellWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  async getAuthenticationSettings(companyId): Promise<any> {
    return this.dataProvider.getAuthenticationSettings(companyId);
  }
}
